import {Component, h} from "preact";
import styles from "./style.module.scss"
import {icons} from '../icons';
import actions from "../../store/actions";
import {i18nService} from "../../services/i18n-service";
import {connect} from "redux-zero/preact";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {config} from "../../config";
import Button from "../button";
import Input from "../input";

interface Props {
  closeInterstitial();

  isMobile: boolean;
}

interface State {
  emailValue: string;
  passwordValue: string;
  showError: boolean;
  disableLoginButton: boolean;
  saveLogin: boolean;
}

class Interstitial extends Component<Props, State> {

  state: State = {
    emailValue: '',
    passwordValue: '',
    showError: false,
    disableLoginButton: true,
    saveLogin: false
  };


  constructor() {
    super();
    this.handleCloseOnBackground = this.handleCloseOnBackground.bind(this);
    this.handleCloseOnX = this.handleCloseOnX.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleStayLoggedIn = this.handleStayLoggedIn.bind(this);
  }

  componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'visible';
  }

  handleCloseOnBackground(e: Event) {
    if (e.target === e.currentTarget) {
      this.props.closeInterstitial();
    }
  }

  handleCloseOnX() {
    this.props.closeInterstitial();
  }

  handleBack() {
    this.props.closeInterstitial();
  }


  handleValidation() {
    if (this.state.emailValue === '' || this.state.passwordValue === '') {
      this.setState({disableLoginButton: true});
      return false;
    } else {
      this.setState({disableLoginButton: false});
      return true;
    }
  }

  countryHasLoyalty(): boolean {
    let CountryService = null;
    if (window['NY_COUNTRY_SERVICE']) {
      CountryService = window['NY_COUNTRY_SERVICE'];
    }
    if (CountryService && CountryService.currentCountry) {
      return CountryService.currentCountry.loyalty;
    }
  }

  handleStayLoggedIn(e) {
    this.setState({saveLogin: e.target.checked});
  }

  async handleLogin() {
    if (this.handleValidation()) {
      this.setState({showError: false, disableLoginButton: true});
      let CustomerService = null;
      if (window && window['NY_CUSTOMER_SERVICE']) {
        CustomerService = window['NY_CUSTOMER_SERVICE'];
      }
      if (!CustomerService) {
        console.error("no NY_CUSTOMER_SERVICE available");
        return;
      }
      const customer = await CustomerService.login(this.state.emailValue, this.state.passwordValue, this.state.saveLogin);
      if (customer) {
        this.props.closeInterstitial();
        this.setState({disableLoginButton: false});
      } else {
        this.setState({showError: true, disableLoginButton: false});
      }
    }
  }

  render() {
    return (
      <div class={styles["interstitial-background"]} onClick={this.handleCloseOnBackground}>
        <div class={styles["interstitial-container"]}>
          {!this.props.isMobile &&
            <span class={styles.close} onClick={this.handleCloseOnX}>{icons.renderCloseIcon()}</span>}
          {this.props.isMobile &&
            <span class={styles.back} onClick={this.handleBack}>{icons.renderArrowLeftIcon()}</span>}
          <div class={styles.content}>
            {this.countryHasLoyalty() && <div class={styles['logo-container']}>
              <img src={`${config.publicPath}images/logos/GetMore.png`}/>
            </div>}
            <div class={styles['text-container']}>
              <div class={styles['info']}>
                {!this.state.showError && i18nService.translate('login_info_text')}
              </div>
              {this.state.showError && <div class={styles['error']}>
                <div class={styles['exclamation-point']}>
                  {icons.renderExclamationPoint()}
                </div>
                <div class={styles['error-message']}>
                  {i18nService.translate('login_error_text')}
                </div>
              </div>}
            </div>
            <div class={styles['login-inputs']}>
              <Input type={'email'}
                     placeholder={i18nService.translate('login_input_email')}
                     required={true}
                     autocomplete={'email'}
                     onInputCallback={(value: string) => {
                       this.setState({emailValue: value}, () => this.handleValidation());
                     }}
                     onEnterCallback={this.handleLogin}/>

              <Input type={'password'}
                     placeholder={i18nService.translate('login_input_password')}
                     required={true}
                     autocomplete={'password'}
                     onInputCallback={(value: string) => {
                       this.setState({passwordValue: value}, () => this.handleValidation());
                     }}
                     onEnterCallback={this.handleLogin}/>
            </div>
            <div class={styles["stay-logged-reset-password-container"]}>
              <div>
                <input onClick={this.handleStayLoggedIn} type="checkbox"
                       class={styles["product-client-checkbox"]} id="product-client-checkbox"
                       name="product-client-checkbox"/>
                <label class={styles["product-client-checkbox-label"]}
                       htmlFor="product-client-checkbox">{i18nService.translate('login_checkbox_stay_logged_in')}</label>
              </div>
              <Button label={i18nService.translate('login_button_reset_password')}
                      onClickCallback={() => location.href = '/customer-profile/#/public/customer-profile/reset-password'}
                      text={true}/>
            </div>
            <div class={styles['login-buttons']}>
              <Button label={i18nService.translate('login_button_login')}
                      onClickCallback={this.handleLogin} red={true}
                      disabled={this.state.disableLoginButton}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, actions)(withDeviceIndicator(Interstitial));